export const ADMIN_AUTH_TOKEN_STORAGE_KEY = 'admin-authorization-token';
export const ADMIN_AUTH_EXPIRES_AT_STORAGE_KEY = 'admin-auth-expires-at';

export const getStoredAdminToken = () =>
  localStorage.getItem(ADMIN_AUTH_TOKEN_STORAGE_KEY) || '';

export const getStoredAdminExpiresAt = () => {
  const rawValue = localStorage.getItem(ADMIN_AUTH_EXPIRES_AT_STORAGE_KEY);
  const expiresAt = Number(rawValue);

  if (!Number.isFinite(expiresAt)) return null;
  return expiresAt;
};

export const hasStoredAdminSession = () => {
  const token = getStoredAdminToken();
  const expiresAt = getStoredAdminExpiresAt();

  if (!token) return false;
  if (!expiresAt) return true;
  return expiresAt > Date.now();
};

export const storeAdminSession = ({
  token,
  expiresAt,
}: {
  token: string;
  expiresAt?: number | null;
}) => {
  localStorage.setItem(ADMIN_AUTH_TOKEN_STORAGE_KEY, token);

  if (expiresAt) {
    localStorage.setItem(ADMIN_AUTH_EXPIRES_AT_STORAGE_KEY, String(expiresAt));
  } else {
    localStorage.removeItem(ADMIN_AUTH_EXPIRES_AT_STORAGE_KEY);
  }
};

export const clearAdminSession = () => {
  localStorage.removeItem(ADMIN_AUTH_TOKEN_STORAGE_KEY);
  localStorage.removeItem(ADMIN_AUTH_EXPIRES_AT_STORAGE_KEY);
};
